
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from '../Pages/home';
import Report from "../Pages/report";
import DashBoard from "../Pages/Dashboard"
import AutomateStockRecord  from "../Pages/AutomateStockRecord"
import StockLevel from "../Pages/stocklevel";
import MCXDashBoard from "../Pages/mcxdashboard"
import PrivateRoute from "../PrivateRoute";
import NewLogin from "../Pages/newlogin";
import ForgotPassword from '../Pages/forgetpassword';
import ForgotPasswordLink from '../Pages/forgerpasswordLink';

//  Access control routes 

import Userlist from '../Pages/Access Control/userlist';
import EditProfile from '../Pages/Access Control/editprofile';
import ViewProfile from '../Pages/Access Control/viewprifile';
import UserCreateForm from '../Pages/Access Control/userCreateForm';
import Commentry from '../Pages/Access Control/commentry';
import SendCommentry from '../Pages/Access Control/sendcommentry';
import Createreport from '../Pages/Access Control/createreport';
import CreateIndexIntraDayReport from '../Pages/Access Control/index_intraday';
import Createmcxreport from '../Pages/Access Control/createmcxreport';
import Createreport360 from '../Pages/report360home';
import PerformanceMonitor from '../Pages/performancemonitor';
import HeartbeatMonitor from '../Pages/heartbeatmonitor';
import Viewreport from '../Pages/Access Control/viewreport';
import ViewpdfReport from '../Pages/Access Control/viewpdfReport';
import StockGT from '../Pages/StockGT'
import StockSR from '../Pages/stockSR'
import FutureTab from '../components/dashboard/futuretab'
import OptionTab from '../components/dashboard/optiontab'
import IntraDayTab from '../components/dashboard/intraDaytab'
import HniTab from '../components/dashboard/hnitab'
import DeliveryTab from '../components/dashboard/deliverytab'
import AutomateReknko from "../Pages/Access Control/automateRenko";
import ViewRenko from "../Pages/Access Control/viewRenko";
import StockInterval from "../Pages/stockInterval";
import { CredentialComponent } from '../components/credentials';
import RouteTracker from "./routeTracker";

import StockSRLevel from "../Pages/stockSRLevel";
const RouteStack = ()=> {

  return ( 
    <CredentialComponent.Consumer>
    
 {({isAuthenticated}) => (
       <Router>
        <RouteTracker isAuthenticated={isAuthenticated} />
       <Routes>
       {/* <Route path="/" element={<Login  onLogin={handleLogin}/>} /> */}
       <Route path="/login" element={<NewLogin/>} /> 
       <Route path= '/forgotpassword' element={<ForgotPassword/>}/>
       {isAuthenticated ?<>
       <Route path="/"  element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Home/>} /></React.Fragment>} />
       <Route path="/home" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Home/>} /></React.Fragment>} />
       <Route path="/report" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Report/>} /></React.Fragment>} />
       <Route path="/dashboard" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<DashBoard/>} /></React.Fragment>} />
       <Route path="/automatescriptrecord" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<AutomateStockRecord/>} /></React.Fragment>} />
       <Route path="/stocklevel" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<StockLevel/>} /></React.Fragment>} />
       <Route path="/stockInterval" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<StockInterval/>} /></React.Fragment>} />
       <Route path="/addGT" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<StockGT/>} /></React.Fragment>} />
       <Route path="/addSR" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<StockSR/>} /></React.Fragment>} />

      <Route path="/addSRLevel" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<StockSRLevel />}/></React.Fragment>}/>

       <Route path="/mcxdashboard" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<MCXDashBoard/>} /></React.Fragment>} />
       <Route path="/futureTab" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<FutureTab/>} /></React.Fragment>} />
       <Route path="/optionTab" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<OptionTab/>} /></React.Fragment>} />
       <Route path="/intraDayTab" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<IntraDayTab/>} /></React.Fragment>} />
       <Route path="/hniTab" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<HniTab/>} /></React.Fragment>} />
       <Route path="/deliveryTab" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<DeliveryTab/>} /></React.Fragment>} />
       <Route path="/userlist" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Userlist/>} /></React.Fragment>} />
       <Route path="/usercreateForm" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<UserCreateForm/>} /></React.Fragment>} />
       <Route path="/commentry" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Commentry/>} /></React.Fragment>} />
       <Route path="/sendcommentry" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<SendCommentry/>} /></React.Fragment>} />
       <Route path="/createreport" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Createreport/>} /></React.Fragment>} />
       <Route path="/create-Index-IntraDay" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<CreateIndexIntraDayReport/>} /></React.Fragment>} />
       <Route path="/createmcxreport" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Createmcxreport/>} /></React.Fragment>} />
       <Route path="/createreport360" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Createreport360/>} /></React.Fragment>} />
       <Route path="/viewreport" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<Viewreport/>} /></React.Fragment>} />
       <Route path="/viewPdfReport" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<ViewpdfReport/>} /></React.Fragment>} />
       <Route path="/performancemonitor" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<PerformanceMonitor/>} /></React.Fragment>} />
       <Route path="/HeartbeatMonitor" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<HeartbeatMonitor/>} /></React.Fragment>} />
       <Route path="/renkoview" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<ViewRenko/>} /></React.Fragment>} />
       <Route path="/automateRenko" element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<AutomateReknko/>} /></React.Fragment>} />


       <Route  path= '/editprofile' element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated} element={<EditProfile/>} /></React.Fragment>} />
       <Route  path= '/viewprofile' element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated}  element={<ViewProfile/>} /></React.Fragment>} />
       <Route  path= '/newlogin' element={<React.Fragment><PrivateRoute isAuthenticated={isAuthenticated}  element={<NewLogin/>} /></React.Fragment>} />

 
         </>
          :
          <> 
          <Route path="/" element={<NewLogin/>} /> 
          <Route path="/login" element={<NewLogin/>} /> 
          <Route path= '/forgotpassword' element={<ForgotPassword/>}/>
          <Route path= '/forgetPassword/:id/verify/:token' element={<ForgotPasswordLink/>}/>
          </>
          
          }
       </Routes>
     </Router>  
      )}

  

    </CredentialComponent.Consumer>

 );
}

export default RouteStack;
